module.exports = __webpack_public_path__ + "img/respeito.3e88f092.svg";